import React, { useState } from "react";
import { Modal, Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";


const MAX_BILL_NUMBER = 10000000000000000000000;


const CustomBillNumberModal = ({ show, onClose, onSave }) => {
    const [billNumber, setBillNumber] = useState("");
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const value = e.target.value;
        // Allow only numeric values
        if (!/^\d*$/.test(value)) return;
        setBillNumber(value);
        setError(""); // Clear previous errors
    };

    const handleSave = () => {
        const number = parseInt(billNumber, 10);
        if (isNaN(number) || number < 0) {
            setError("Please enter a valid numeric value (0 or greater).");
            return;
        }
        if (number > MAX_BILL_NUMBER) {
            setError(`The bill number cannot exceed 10000000000000000000000.`);
            return;
        }
        onSave(number);
        setBillNumber("");
    };

    const handleClose = () => {
        onClose();
        setBillNumber("");
        setError("");
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Enter Starting Bill Number</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormGroup controlId="formBillNumber">
                    <ControlLabel>Bill Number (0 or greater)</ControlLabel>
                    <FormControl
                        type="text"
                        value={billNumber}
                        placeholder="Enter bill number"
                        onChange={handleChange}
                    />
                    {error && <div style={{ color: "red", marginTop: "5px" }}>{error}</div>}
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClose}>Cancel</Button>
                <Button bsStyle="primary" onClick={handleSave}>Save</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomBillNumberModal;
